'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.interactive = void 0;
var groundsCallBackIndex = 0;
function _creatFun(t) {
    var n = '__grounds_' + Number(Math.floor(10000000000 * Math.random())).toString(36) + groundsCallBackIndex++;
    return window[n] = function (n) {
        t(n);
    }, n;
}
var interactive = {
    intercall: function (n, t) {
        var o = _creatFun(t);
        grounds[n](o);
    },
    on: function (n, t) {
        var o = _creatFun(t);
        grounds.on(n, o);
    },
    userIsLogin: function () {
        return grounds.userIsLogin();
    },
    userLogin: function () {
        grounds.userLogin();
    },
    openShare: function () {
        var n;
        (n = grounds).openShare.apply(n, arguments);
    },
    dispatch: function (n, t) {
        grounds.dispatch(n, t);
    },
    pushSwitch: function () {
        grounds.pushSwitch();
    },
    pushState: function (t) {
        window.pushStateCallBack = function (n) {
            t(n), window.pushStateCallBack = null;
        }, grounds.pushState();
    },
    isPushActivated: function (t) {
        grounds.isPushActivated('isPushActivatedCallBack'), window.isPushActivatedCallBack = function (n) {
            t(n);
        };
    },
    gotoTabMenu: function (n, t) {
        grounds.gotoTabMenu(n, t);
    },
    maximization: function () {
        void 0 !== grounds.maximization && grounds.maximization(), void 0 !== grounds.setMultiToolBarHidden && grounds.setMultiToolBarHidden(!0);
    },
    exitMaximization: function () {
        void 0 !== grounds.exitMaximization && grounds.exitMaximization(), void 0 !== grounds.setMultiToolBarHidden && grounds.setMultiToolBarHidden(!1);
    },
    setMultiToolBarHidden: function (n) {
        void 0 !== grounds.setMultiToolBarHidden && grounds.setMultiToolBarHidden(n);
    },
    rotate: function (n) {
        grounds.rotate(n);
    },
    close: function () {
        grounds.close();
    },
    setShareVisibility: function (n) {
        grounds.setShareVisibility(n);
    },
    keyValueFetch: function (n, t) {
        var o = _creatFun(t);
        grounds.keyValueFetch(n, o);
    },
    keyValueStore: function (n, t) {
        grounds.keyValueStore(n, t);
    },
    signInSuccess: function () {
        grounds.signInSuccess();
    },
    nativeRequest: function (o) {
        return o.getParams = o.getParams || '', o.postParams = o.postParams || '', o.standards = !0, new Promise(function (t) {
            var n = _creatFun(function (n) {
                t(JSON.parse(decodeURIComponent(n)));
            });
            grounds.requestBridge(o.url, o.postParams, o.getParams, o.type, o.standards, n);
        });
    },
    jumpInNative: function (n) {
        switch (n.type) {
        case 'article':
            return grounds.dispatch('doc', 'ucms_'.concat(n.base62Id));
        case 'video':
            return grounds.dispatch('phvideo', 'ucms_'.concat(n.base62Id));
        case 'slide':
            return grounds.dispatch('slide', 'https://nine.ifeng.com/GetNewsDocs?aid=ucms_'.concat(n.base62Id));
        case 'special':
            return grounds.dispatch('topic3', 'https://nine.ifeng.com/newTopic?topicid='.concat(n.base62Id, '&json=y'));
        default:
            return grounds.dispatch('web', n.url);
        }
    }
};
exports.interactive = interactive;